import React from "react";

import { Box } from "@mui/material";
import MainHeader from "../../shared/MainHeader";

import AssignPubCaseTable from "../../components/AssignPubCaseTable";

const PublicCase = () => {
  return (
    <Box>
      <MainHeader headingText={"Unassigned Public Case"} />

      <AssignPubCaseTable />
    </Box>
  );
};

export default PublicCase;
